module.exports = __webpack_public_path__ + "img/PaymentFail.29ec5d54.png";